import { callApi } from "./api.service";

//Define the function to get active Memberships of user.
export const GetMemberships = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = "/api/membership/get-membership";
  return await callApi(endpoint, "GET", true, getToken);
};

//Define the function to get Membership history of user.
export const GetMembershipHistory = async (
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/membership/get-membership-history`;
  return await callApi(endpoint, "GET", true, getToken);
};